#version 300 es
precision highp float;

uniform highp sampler3D tex;
uniform vec2 windowLevel;
uniform float alpha;
uniform int colormapType;
uniform bool premultiplyAlpha;

in vec3 vTextureCoords;
out vec4 fragColor;

vec3 hotColormap(float t) {
    return vec3(
        clamp(t * 3.0, 0.0, 1.0),
        clamp(t * 3.0 - 1.0, 0.0, 1.0),
        clamp(t * 3.0 - 2.0, 0.0, 1.0)
    );
}

vec3 rainbowColormap(float t) {
    if (t < 0.25) {
        return mix(vec3(0.0, 0.0, 0.0), vec3(0.0, 0.0, 1.0), t * 4.0);
    } else if (t < 0.5) {
        return mix(vec3(0.0, 0.0, 1.0), vec3(0.0, 1.0, 1.0), (t - 0.25) * 4.0);
    } else if (t < 0.75) {
        return mix(vec3(0.0, 1.0, 1.0), vec3(1.0, 1.0, 0.0), (t - 0.5) * 4.0);
    } else {
        return mix(vec3(1.0, 1.0, 0.0), vec3(1.0, 0.0, 0.0), (t - 0.75) * 4.0);
    }
}

vec3 invertGrayscaleColormap(float t) {
    float inv = 1.0 - t;
    return vec3(inv, inv, inv);
}


vec3 greenColormap(float t) {
    return vec3(
        clamp(t * 3.0 - 1.0, 0.0, 1.0),
        clamp(t * 3.0, 0.0, 1.0),
        clamp(t * 3.0 - 2.0, 0.0, 1.0)
    );
}

vec3 rainbowTwoColormap(float t) {
    if (t < 0.25) {
        return mix(vec3(0.0, 0.0, 0.04), vec3(0.32, 0.06, 0.44), t * 4.0);
    } else if (t < 0.5) {
        return mix(vec3(0.32, 0.06, 0.44), vec3(0.73, 0.21, 0.33), (t - 0.25) * 4.0);
    } else if (t < 0.75) {
        return mix(vec3(0.73, 0.21, 0.33), vec3(0.99, 0.56, 0.15), (t - 0.5) * 4.0);
    } else {
        return mix(vec3(0.99, 0.56, 0.15), vec3(0.99, 0.99, 0.64), (t - 0.75) * 4.0);
    }
}

vec3 spectrumColormap(float t) {
    if (t < 0.1) {
        return mix(vec3(0.0, 0.0, 0.0), vec3(0.27, 0.0, 0.33), t * 10.0);
    } else if (t < 0.325) {
        return mix(vec3(0.27, 0.0, 0.33), vec3(0.28, 0.14, 0.47), (t - 0.1) / 0.225);
    } else if (t < 0.55) {
        return mix(vec3(0.28, 0.14, 0.47), vec3(0.13, 0.37, 0.52), (t - 0.325) / 0.225);
    } else if (t < 0.775) {
        return mix(vec3(0.13, 0.37, 0.52), vec3(0.37, 0.65, 0.35), (t - 0.55) / 0.225);
    } else {
        return mix(vec3(0.37, 0.65, 0.35), vec3(0.99, 0.91, 0.14), (t - 0.775) / 0.225);
    }
}

vec3 applyColormap(float t, int type) {
    if (type == 1) return greenColormap(t);
    if (type == 2) return rainbowColormap(t);
    if (type == 3) return rainbowTwoColormap(t);
    if (type == 4) return spectrumColormap(t);
    if (type == 5) return invertGrayscaleColormap(t);
    return hotColormap(t); // 0 = default
}

void main() {
    float value = texture(tex, vTextureCoords).r;

    float t = (value - windowLevel.y + (windowLevel.x * 0.5)) / windowLevel.x;
    vec3 color = applyColormap(t, colormapType);
    float intensity = clamp(t, 0.0, 1.0);
    float gate = mix(intensity, 1.0, alpha * alpha);
    float weight = alpha * gate;

    if (premultiplyAlpha) {
        fragColor = vec4(color * weight, 1.0);
    } else {
        fragColor = vec4(color, weight);
    }
}
